import React from "react";
import PropTypes from "prop-types";
import { useDispatch } from "react-redux";
import styled from "@emotion/styled";
import { setMerchantIsRequired } from "../../Merchants";

const Container = styled.div`
  flex: 1 1 0%;
  margin: 0px 10px;
`;

const RefId = ({
  merchantSelectorFocus,
  defaultValue,
  onChange,
  hasMerchant,
  maxLength,
}) => {
  const dispatch = useDispatch();

  const onFocus = () => {
    if (!hasMerchant) {
      dispatch(setMerchantIsRequired(true));
      merchantSelectorFocus();
    }
  };

  return (
    <Container>
      <input
        defaultValue={defaultValue}
        type="text"
        onChange={onChange}
        onFocus={() => onFocus()}
        className={"form-control"}
        placeholder={"Ref ID (Optional)"}
        size={maxLength}
      />
    </Container>
  );
};

RefId.DefaultProps = {
  defaultValue: null,
};

RefId.propTypes = {
  merchantSelectorFocus: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  hasMerchant: PropTypes.bool.isRequired,
  maxLength: PropTypes.number,

  defaultValue: PropTypes.string,
};

export { RefId };
